<div class="header-container">
  @if (pageHeader.config(); as page) {
    <div class="header-page">
      @if (page.back) {
        <button
          mat-icon-button
          type="button"
          class="header-page__back"
          [matTooltip]="page.backTooltip ?? ''"
          (click)="page.back()"
          aria-label="back"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      @if (page.icon; as icon) {
        <div class="header-page__icon">
          @if (icon.startsWith('hgi')) {
            <mat-icon fontSet="hgi" [fontIcon]="icon"></mat-icon>
          } @else {
            <mat-icon>{{ icon }}</mat-icon>
          }
        </div>
      }
      <div class="header-page__titles">
        @if (page.title) {
          <span class="header-page__title">{{ page.title }}</span>
        }
        @if (page.subtitle) {
          <span class="header-page__subtitle">{{ page.subtitle }}</span>
        }
      </div>
    </div>
  }
  <div class="header-actions">
    <!-- Client logo, ahead of the filter bar. With a `background` it becomes the coloured left
         end of the strip; without one it just sits inline. Both come from the host application,
         so another client passes its own pair and one with none changes nothing. -->
    @if (brandLogo; as logo) {
      <div
        class="header-brand"
        [class.header-brand--filled]="!!logo.background"
        [style.background-color]="logo.background ?? null"
      >
        <img class="header-brand__logo" [src]="logo.url" [alt]="logo.alt ?? 'logo'" />
      </div>
    }
    @if (pageHeader.config(); as page) {
      @if (page.content) {
        <div class="header-page__content">
          <ng-container [ngTemplateOutlet]="page.content"></ng-container>
        </div>
      }
      @for (action of page.actions ?? []; track action.id) {
        @switch (action.variant) {
          @case ('icon') {
            <button
              mat-icon-button
              type="button"
              [disabled]="action.disabled"
              [matTooltip]="action.tooltip ?? ''"
              (click)="action.run()"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
            </button>
          }
          @case ('fab') {
            <button
              mat-mini-fab
              type="button"
              class="hb-fab"
              [color]="action.color ?? 'primary'"
              [disabled]="action.disabled"
              [matTooltip]="action.tooltip ?? ''"
              (click)="action.run()"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
            </button>
          }
          @case ('stroked') {
            <button
              mat-stroked-button
              type="button"
              [color]="action.color"
              [disabled]="action.disabled"
              [matTooltip]="action.tooltip ?? ''"
              (click)="action.run()"
            >
              @if (action.icon) {
                <mat-icon>{{ action.icon }}</mat-icon>
              }
              {{ action.label }}
            </button>
          }
          @default {
            <button
              mat-flat-button
              type="button"
              [color]="action.color ?? 'primary'"
              [disabled]="action.disabled"
              [matTooltip]="action.tooltip ?? ''"
              (click)="action.run()"
            >
              @if (action.icon) {
                <mat-icon>{{ action.icon }}</mat-icon>
              }
              {{ action.label }}
            </button>
          }
        }
      }
    }
    <!-- Global assistant (WB-155): routes a request to the agent that handles it, from any screen -->
    <wbi-global-assistant></wbi-global-assistant>
    <!-- Notifications: compact unread list, "see more" opens /notifications -->
    <button
      mat-icon-button
      class="notification-button"
      #notificationTrigger="matMenuTrigger"
      [matMenuTriggerFor]="notificationMenu"
      [matTooltip]="'$notifications.title' | translateAsync"
      [attr.aria-label]="'$notifications.title' | translateAsync"
    >
      <mat-icon
        [matBadge]="badgeText()"
        [matBadgeHidden]="!hasNotifications()"
        fontSet="hgi"
        class="custom-badge hgi-notification-02"
        aria-hidden="false"
      ></mat-icon>
    </button>
    <mat-menu
      #notificationMenu="matMenu"
      class="notification-menu"
      [hasBackdrop]="true"
      [overlapTrigger]="false"
    >
      <!-- Stops menu-item keyboard handling from swallowing the clicks inside the panel. -->
      <div
        (click)="$event.stopPropagation()"
        (keyup.enter)="$event.stopPropagation()"
        tabindex="-1"
      >
        <wbi-notification-menu (closed)="notificationTrigger.closeMenu()"></wbi-notification-menu>
      </div>
    </mat-menu>
    <!-- Profile Avatar -->
    <mat-divider [vertical]="true"> </mat-divider>
    <div class="avatar">
      <img src="../../assets/images/user-avatar.svg" alt="Profile" class="profile-image" />
    </div>
  </div>
</div>
